import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import {
  scale020,
  scale200,
  spaceXL,
  spaceXXL,
  space3XL,
} from '@xing-com/tokens';
import { Meta, Headline, BodyCopy } from '@xing-com/typography';

export const Container = styled.section`
  margin-bottom: calc(${scale020} + ${scale200});
`;

export const Title = styled(Headline)`
  margin-bottom: ${spaceXXL};
`;

export const Text = styled(BodyCopy)`
  margin-bottom: ${space3XL};
`;

export const MainInsightsTitle = styled(Meta)`
  margin-bottom: ${spaceXL};
  text-align: center;

  @media ${mediaConfined} {
    text-align: justify;
  }
`;
